import React from 'react';

import { PaneCard, Divider } from '../../../../components/wizard';
import { useConfigurator } from '../../../../store/configurator';
import { ColorSwatch } from '../ColorSwatch';
import { StyleCard } from '../StyleCard';
import { Heading, Groups, Group, SectionLabel, ColorGrid, StyleList } from './ColorStyling.styles';

/**
 * Brand colours (skins) + art styles for the selected theme. Both lists render in
 * full: colours as a three-per-row grid (each swatch grows to fill its column,
 * square), art styles stacked full-width beneath each other — no collapse / browse.
 */
export const ColorStyling = (): React.ReactElement => {
  const { colors, selectedColor, setColor, styles, selectedStyle, setStyle } = useConfigurator();

  return (
    <PaneCard>
      <Heading text="Color & styling" tag="paragraph" />

      <Divider />

      <Groups>
        <Group>
          <SectionLabel text="Colors" tag="paragraph" />
          <ColorGrid>
            {colors.map((color) => (
              <ColorSwatch
                key={color.id}
                color={color}
                selected={color.id === selectedColor?.id}
                onClick={() => setColor(color.id)}
              />
            ))}
          </ColorGrid>
        </Group>

        <Group>
          <SectionLabel text="Styles" tag="paragraph" />
          {/* Keyed on the selected colour: switching colour swaps the compatible
              art-style set, so this remounts and the new tiles animate in. */}
          <StyleList key={selectedColor?.id ?? 'none'}>
            {styles.map((style) => (
              <StyleCard
                key={style.id}
                style={style}
                selected={style.id === selectedStyle?.id}
                onClick={() => setStyle(style.id)}
              />
            ))}
          </StyleList>
        </Group>
      </Groups>
    </PaneCard>
  );
};

export default ColorStyling;
